import { render, staticRenderFns } from "./tjsfdx.vue?vue&type=template&id=8c61636e&scoped=true&"
import script from "./tjsfdx.vue?vue&type=script&lang=js&"
export * from "./tjsfdx.vue?vue&type=script&lang=js&"
import style0 from "./tjsfdx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tjsfdx.vue?vue&type=style&index=1&id=8c61636e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c61636e",
  null
  
)

export default component.exports